export { default } from 'webapp/templates/routines/detail';
